export const validateRequiredString = (string: string, message?: string) =>
  String(string).trim() ? "" : message ? message : "Required";

export const validateRequiredNumber =
  (label: string) =>
  (v: string | number): string => {
    const n = typeof v === "string" ? Number(v) : v;
    if (n === null || n === undefined || Number.isNaN(n))
      return `${label} is required`;
    if (n <= 0) return `${label} must be greater than 0`;
    return "";
  };

export const validateRequiredDate = (d: Date | null) =>
  d ? "" : "Date required";

export const normalizePhone = (raw: string): string | null => {
  const v = raw.trim().replace(/[^\d+]/g, "");

  // Kenyan numbers: must be 12 digits, starts with 254, and is numeric
  if (v.startsWith("254") && v.length === 12 && /^\d+$/.test(v)) return v;

  if (v.startsWith("+254") && v.length === 13 && /^\+?\d+$/.test(v))
    return v.slice(1);

  if (v.startsWith("0") && v.length === 10 && /^0\d{9}$/.test(v))
    return `254${v.slice(1)}`;

  if (/^(7\d{8}|1\d{8})$/.test(v)) return `254${v}`;

  // Otherwise, invalid
  return null;
};

export const validatePhone = (value: string, required?: boolean) => {
  const trimmed = value.trim();

  if (required && !trimmed) {
    return "Phone number is required";
  }

  if (!trimmed) return undefined;

  const raw = trimmed.replace(/[^\d+]/g, "");

  const KE_INPUT_REGEX = /^(\+254|254|0)(7\d{8}|1\d{8})$/;

  if (!KE_INPUT_REGEX.test(raw)) {
    return "Enter a valid phone number";
  }
};

export const validateEmail = (value: string, required?: boolean) => {
  const trimmed = value.trim();

  if (required && !trimmed) {
    return "Email is required";
  }

  if (!trimmed) {
    return undefined;
  }

  const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!EMAIL_REGEX.test(trimmed)) {
    return "Enter a valid email address";
  }

  return undefined;
};

export const noopValidator = () => "";

export const requiredValidator = (value: unknown): string => {
  if (value === null || value === undefined || value === "") {
    return "Required";
  }
  if (typeof value === "string" && !value.trim()) {
    return "Required";
  }
  return "";
};
